import React from "react";
import "./Pills.scss";

interface FilterPillsProps {
  filters: { id: any; label: string; field: string }[];
  onRemoveFilter: (filterId: string, field: string) => void;
  onClearFilters: () => void;
}

export const Pills: React.FC<FilterPillsProps> = ({
  filters,
  onRemoveFilter,
  onClearFilters,
}) => {
  return (
    <div className="filter-pills">
      <div className="filter-pills__inner">
        {filters.map((filter) => (
          <button
            key={filter.id}
            className="filter-pills__pill"
            onClick={() => onRemoveFilter(filter.id, filter.field)}
          >
            <span className="filter-pills__pill__icon">✕</span>
            <span dangerouslySetInnerHTML={{ __html: filter.label }}></span>
          </button>
        ))}
      </div>
      {filters.length > 0 && (
        <button
          className="filter-pills__clear-filters"
          onClick={onClearFilters}
        >
          Clear filters
        </button>
      )}
    </div>
  );
};
